import { isRejected, isPending, createSlice } from "@reduxjs/toolkit";

// Prefix of ErrorCodes.INVALID_CUSTOMER (csfa/errorcodes.py). The backend
// appends the customer number, so the code arrives as "c400x<cust#>".
const INVALID_CUSTOMER_PREFIX = "c400x";

export const loadingTracker = createSlice({
  name: "loadingTracker",
  initialState: {
    rejected: false,
    pending: true,
    code: "",
    // A fatal error is a precondition the user cannot retry past (today: no
    // customer number on the account). Once set it is sticky for the life of
    // the page: a pending action must NOT clear it, or the app re-renders the
    // routed tree, remounts every screen, and re-fires every mount-time fetch
    // in a loop that the backend can only answer with the same 412.
    fatal: false,
    fatalCustomerNumber: "",
  },
  reducers: {
    resetErrors: (state) => {
      if (state.fatal) return;
      state.rejected = false;
      state.pending = true;
      state.code = "";
    },
  },
  extraReducers: (builder) => {
    builder
      // Handle specific cases here...
      .addMatcher(isRejected, (state, action) => {
        const code = action?.payload?.code;
        if (code) {
          state.rejected = true;

          state.code = code || "Internal Error";

          if (String(code).startsWith(INVALID_CUSTOMER_PREFIX)) {
            state.fatal = true;
            const custNum = String(code).slice(
              INVALID_CUSTOMER_PREFIX.length,
            );
            state.fatalCustomerNumber =
              custNum && custNum !== "NaN" ? custNum : "";
          }
        }
        state.pending = false;
      })
      .addMatcher(isPending, (state, action) => {
        if (state.fatal) return;
        state.rejected = false;
        state.pending = true;
      });
  },
});

export const { resetErrors } = loadingTracker.actions;

export default loadingTracker.reducer;
